import { helpers } from '@linqpal/common-frontend'
import React, { useMemo } from 'react'
import { View } from 'react-native'
import { Button as PaperButton } from 'react-native-paper'
import { commonColors } from '@linqpal/common-frontend/src/theme'

const { composeStyle, webSpecificStyle } = helpers

interface PropTypes {
  block?: boolean
  style?: any
  buttonStyle: any
  contentStyle?: any
  disabled?: boolean
  mode?: 'text' | 'outlined' | 'contained'
  labelStyle?: any
  compact?: any
  children: any
  onPress: (a?) => void
  loading?: boolean
  testID?: string
}

export const BButton = ({
  block = false,
  style = {},
  buttonStyle,
  contentStyle = {},
  disabled = false,
  mode,
  labelStyle,
  compact,
  ...props
}: PropTypes) => {
  const { backgroundColor, opacity } = useMemo(
    () => ({
      backgroundColor: !disabled ? commonColors.accentText : '#0070AA',
      opacity: disabled && 0.2,
    }),
    [disabled],
  )

  return (
    <View
      style={composeStyle(
        {
          alignItems: block ? 'stretch' : 'flex-start',
          alignSelf: block && 'stretch',
        },
        style,
      )}
    >
      <PaperButton
        disabled={disabled}
        contentStyle={composeStyle(!compact && { height: 48 }, contentStyle)}
        uppercase={false}
        mode={mode || 'contained'}
        theme={{ roundness: 8 }}
        labelStyle={composeStyle(
          { fontSize: 16, padding: 2, fontWeight: '500', color: 'white' },
          webSpecificStyle({ userSelect: 'none' }),
          labelStyle,
        )}
        style={[{ backgroundColor }, { opacity }, buttonStyle]}
        {...props}
      />
    </View>
  )
}
